<template>
    <!-- Comapny Basic Info Tab Content View From Company Profile -->
    <div>
        <!-- <div class="tabs-content-firstblock mb-4">
      <div class="row">
        <div class="col-lg-12">
          <div class="infoHeader ml-2 mr-1">
            <div class="descriptionheader">
              <div class="description-text-header-left">
                <h5>
                  <i class="crmnew-info iconsize-16 pr-1 defaultBlue"></i>
                  About
                </h5>
              </div>
            </div>
          </div>
          <div class="textTitle ml-6 mr-2">
            {{ companyData.about }}
          </div>
        </div>
      </div>
    </div>-->
        <div class="tabs-content-secondblock">
            <div class="row">
                <div class="col-lg-12">
                    <div class="infoHeader ml-2 mr-1">
                        <div class="descriptionheader">
                            <div class="description-text-header-left col-md-10">
                                <h5 class>
                                    <i class="crmnew-basic iconsize-16 pr-1 defaultBlue"></i>
                                    Basic Information
                                </h5>
                            </div>
                            <a v-if="$store.getters.account == $route.params.id" href="javascript:;"
                                class="btn btn-secondary btn-smm pull-right col-md-2" v-on:click="editCompanyProfile()">
                                <i class="icon-pencil pr-1" style="font-size: 16px;"></i>
                                Edit
                            </a>
                        </div>
                    </div>
                    <!-- <div class="header-inline">
              <div class="headerTitleView ml-8">
                  <span class="fs-14 defaultBlue aboutHeading">Basic Information</span>
              </div>
              <span class="header-inline-edit">
                  <i class="icon icon-pencil"></i>
              </span>
          </div>-->
                    <div class="ml-2 mr-1 mb-3">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="infoHeader mt-4 pb-4">
                                    <div class="a-q-Jc-j-contactView mt-1">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Company Name</div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                                <span
                                                    class="a-q-Jc-wg-contactView font-color">{{ companyData.company_name || "-" }}</span>
                                                <!-- <span class="a-q-Jc-wg-contactView font-color">
                                                <div class="input-group digi-input-group">
                                                    <input type="text" class="form-control" value="Dell India Pvt Ltd">
                                                    <span class="input-group-addon">
                                                        <i class="icon-close-circle-outline" style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                    </span>
                                                </div>
                      </span>-->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Industry Type</div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                                <span
                                                    class="a-q-Jc-wg-contactView text-runcate">{{ companyData.company_type || "-" }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Domain Name</div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                                <!-- <span class="a-q-Jc-wg-contactView">
                        {{ companyData.company_domain || '-' }}
                      </span>-->

                                                <span class="a-q-Jc-wg-contactView"
                                                    v-for="(domain, index) in companyData.company_domain" :key="index">
                                                    <span class="chipdietary mb-0" style="font-weight:600!important;padding:0px!important;color:#303031!important;background: transparent !important;">
                                                        <a :href="domain" target="_blank">{{ domain || '-' }}</a>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">About</div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                                <span class="a-q-Jc-wg-contactView">
                                                    {{ companyData.about }}
                                                </span>
                                            </div>
                                        </div>
                                        <!-- <span class="a-q-Jc-wg-contactView" style="text-align:right">

                  </span>-->
                                    </div>
                                </div>
                                <div class="infoHeader mt-4 pb-4">
                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">
                                                Date of Incorporation
                                                <br />(dd/mm/yyyy)
                                            </div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item mt-3">
                                                <span class="a-q-Jc-wg-contactView">
                                                    {{moment(companyData.date_of_incorporation).format("DD/MM/YYYY") || "-"}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Time Zone</div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                                <span
                                                    class="a-q-Jc-wg-contactView">{{ companyData.time_zone || "-" }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Number of Employees</div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                                <span
                                                    class="a-q-Jc-wg-contactView">{{ companyData.number_of_employees || "-" }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Fiscal Year Name</div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                                <span
                                                    class="a-q-Jc-wg-contactView">{{ companyData.fiscal_year || "-" }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">
                                                Start Date
                                                <br />(dd/mm/yyyy)
                                            </div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item mt-3">
                                                <span class="a-q-Jc-wg-contactView">
                                                    {{moment(companyData.fiscal_year_start_date).format("DD/MM/YYYY") || "-"}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">
                                                End Date
                                                <br />(dd/mm/yyyy)
                                            </div>
                                            <div class="a-q-Jc-Lb-contactView new-contactView-item mt-3">
                                                <span class="a-q-Jc-wg-contactView">
                                                    {{moment(companyData.fiscal_year_end_date).format("DD/MM/YYYY") || "-"}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="a-q-Jc-j-contactView">
                  <div class="a-q-Jc-Pj-Ya-contactView" style="border-bottom: solid 1px transparent !important;">
                    <div class="a-q-Jc-bj-contactView defaultBlue">Scan Code</div>
                    <div class="a-q-Jc-Lb-contactView">
                      <span class="a-q-Jc-wg-contactView">
                        <div class="qrcode-block-view-company">
                          <img src="/static/images/qr-logo-dg.svg" alt="QR Code" class="qr-logo-view-company">
                          <qrcode-vue :value="valueqr" :size="size" level="H" background="#d6e2ef" foreground="#00448b" class="qrcode-content-view-company"></qrcode-vue>
                        </div>
                      </span>
                    </div>
                  </div>
              </div>-->
                        </div>
                        <!-- <div class="col-lg-4">
                <h5 class="fs-15 pt-4 pb-2 text-center fw-600 defaultBlue">Scan Code</h5>
                <div class="qrcode-block-view-company">
                  <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/qr-logo-dg.svg" class="qr-logo-view-company">
                  <qrcode-vue :value="valueqr" :size="size" level="H" background="#d6e2ef" foreground="#00448b" class="qrcode-content-view-company"></qrcode-vue>
                </div>
            </div>-->
                    </div>
                    <!-- <div class="ml-7 mr-6">
                <div class="row">
                    <div class="col-lg-12 text-right">
                        <button type="button" class="btn btn-white btn-smm btn-no-border-blue ml-3" style="color: #00448b;background-color: #fff; box-shadow: none;">CANCEL</button>
                        <button type="button" class="btn btn-secondary btn-smm" style="box-shadow: none;">SAVE</button>
                    </div>
                </div>
          </div>-->
                </div>

                <!-- <div class="infoHeader ml-2 mr-1 mt-5">
            <div class="descriptionheader">
              <div class="description-text-header-left">
                <h5>
                  <i class="icon-calendar-range iconsize-18 pr-1 defaultBlue"></i>
                  Fiscal Year Information
                </h5>
        </div>-->
                <!-- <div class="description-text-header-right">
                  <i class="icon icon-pencil"></i>
        </div>-->
                <!-- </div>
        </div>-->
                <!-- <div class="ml-2 mr-1 mb-3">
            <div class="row">
              <div class="col-lg-12">
                <div class="a-q-Jc-j-contactView mt-1">
                  <div class="a-q-Jc-Pj-Ya-contactView">
                    <div class="a-q-Jc-bj-contactView defaultBlue">Fiscal Year Name</div>
                    <div class="a-q-Jc-Lb-contactView">
                      <span class="a-q-Jc-wg-contactView font-color">
                        {{ companyData.fiscal_year || '-' }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="a-q-Jc-j-contactView mt-1">
                  <div class="a-q-Jc-Pj-Ya-contactView">
                    <div class="a-q-Jc-bj-contactView defaultBlue">Start Date<br>(dd/mm/yyyy)</div>
                    <div class="a-q-Jc-Lb-contactView">
                      <span class="a-q-Jc-wg-contactView font-color">
                        {{ moment(companyData.fiscal_year_start_date).format("DD/MM/YYYY") || '-' }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="a-q-Jc-j-contactView mt-1">
                  <div class="a-q-Jc-Pj-Ya-contactView" style="border-bottom: solid 1px transparent !important;">
                    <div class="a-q-Jc-bj-contactView defaultBlue">End Date<br>(dd/mm/yyyy)</div>
                    <div class="a-q-Jc-Lb-contactView">
                      <span class="a-q-Jc-wg-contactView font-color">
                        {{ moment(companyData.fiscal_year_end_date).format("DD/MM/YYYY") || '-' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>-->
            </div>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import QrcodeVue from "qrcode.vue";
    import EditCompanyProfileVue from "./EditCompanyProfile.vue";
    import EditCompanyProfile from "./EditCompanyProfile";
    export default {
        data() {
            return {
                editing: false,
                valueqr: "https://example.com",
                size: 90,
            };
        },
        props: ["companyData"],
        components: {
            QrcodeVue,
        },
        methods: {
            enableEditing() {
                this.editing = true;
            },
            editCompanyProfile() {
                this.$router.push({
                    name: "EditCompanyProfile",
                    params: {
                        id: this.$route.params.id
                    },
                });
            },
            moment(date) {
                return moment(date);
            },
        },
    };
</script>
<style>
    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-firstblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-secondblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    textarea.textarea-control {
        height: auto;
    }

    textarea.textarea-control {
        display: block;
        width: 100%;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #4e5764;
        background-color: #fff;
        background-image: none;
        border: 1px solid #cdd2da;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        -webkit-transition: border-color ease-in-out 0.15s,
            box-shadow ease-in-out 0.15s;
        -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
        -webkit-transition: border-color ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
    }

    .input-group.digi-input-group {
        border: 1px solid #cdd2da !important;
    }

    .input-group.digi-input-group>.form-control {
        position: relative !important;
        -webkit-box-flex: 1 !important;
        -webkit-flex: 1 1 auto !important;
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
        width: 1% !important;
        margin-bottom: 0 !important;
        height: 22px !important;
        padding: 6px 12px 6px 2px !important;
        color: #4e5764;
        text-decoration: underline;
        border-bottom: 1px solid transparent !important;
    }

    .input-group.digi-input-group .input-group-addon {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid transparent !important;
        padding-top: 2px;
        cursor: pointer;
    }

    .qrcode-block-view-company {
        border-radius: 6px;
        width: 104px;
        height: 105px;
        position: relative;
        display: inline-block;
        display: block;
        border: 1px solid #00448b;
        background: #d6e2ef;
    }

    .qrcode-content-view-company {
        text-align: center;
        margin: 6px auto;
        background: #d6e2ef !important;
    }

    .qr-logo-view-company {
        position: absolute;
        margin-top: 40px;
        margin-left: 35px;
        width: 30px;
    }

    /* .a-q-Jc-Lb-contactView {
        padding: 16px 10px 0px 3px !important;
    } */
    .new-contactView-item{
        padding: 16px 10px 16px 3px !important;
    }
    .new-contactView {
        display: flex;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/CompanyBasicInfoView.vue